import { useCallback, useEffect, useRef, useState } from "react";
import type { PublicEvent } from "../types/public";
import { buildPublicOneTapCopyText, buildPublicOneTapXText, openXIntentCompose } from "../lib/public-share-snippet";

export function PublicEventShareRow({ event }: { event: PublicEvent }) {
  const [copied, setCopied] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);

  const flashCopied = useCallback(() => {
    setCopied(true);
    if (hideTimer.current) clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setCopied(false), 2200);
  }, []);

  const copy = async () => {
    const text = buildPublicOneTapCopyText(event);
    try {
      await navigator.clipboard.writeText(text);
      flashCopied();
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        flashCopied();
      } catch {
        /* ignore */
      }
    }
  };

  const xDraft = () => {
    openXIntentCompose(buildPublicOneTapXText(event));
  };

  return (
    <div className="home-share-row">
      <div className="row home-share-actions home-share-actions--public">
        <button className="btn secondary home-share-big-btn" type="button" onClick={() => void copy()}>
          この情報をコピペ
        </button>
        <button className="btn secondary home-share-big-btn" type="button" onClick={xDraft}>
          X下書き生成
        </button>
      </div>
      {copied ? (
        <p className="home-share-copied-toast" role="status" aria-live="polite">
          コピーしました！
        </p>
      ) : null}
    </div>
  );
}
